import { WorkingHoursSettingModel } from './../models/Booking/WorkingHoursSettingModel';
import { RecivedPaymentModel } from './../models/Payments/RecivedPaymentModel';
import { AccountStatmentModel } from './../models/Payments/AccountStatmentModel';
import { LatestCampaignModel } from './../models/Booking/LatestCampaignModel';
import { CustomerElegibility } from './../models/Booking/CustomerElegibility';
import { LanguageModel } from './../models/LanguageModel';
import { ResourceService } from 'src/app/services/resource.service';
import { Vehicle } from 'src/app/models/Vehicle';
import { ReservationSaveAndConfirmModel } from './../models/Booking/ReservationSaveAndConfirmModel';
import { CrossBorderModel } from './../models/Booking/CrossBorderModel';
import { DriverSkillModel } from './../models/Booking/DriverSkillModel';
import { Injectable } from '@angular/core';
import { BehaviorSubject, ReplaySubject } from 'rxjs';
import { VehicleSearchTypeEnum } from '../models/enums/VehicleSearchTypeEnum';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { LstAdditionalServiceReservationCase, VehicleReservationCaseDetailsModel } from '../models/VehicleReservationCaseDetailsModel'
import { VehicleReservationSearchParm } from '../models/VehicleReservationSearchParm';
import { ApiControllerActionEnum } from '../models/enums/ApiControllerActionEnum';
import { OneWayRentalModel } from '../models/Booking/OneWayRentalModel';
import { EvaluationSummaryModel } from '../models/Evaluation/EvaluationSummaryModel'
import { EvaluationLogsMasterModel } from '../models/Evaluation/EvaluationLogsMasterModel'
import { GetVehicleReservationCasesByCustomerID, ReservationCasesByCustomerIDResult } from '../models/Booking/ReservationCasesByCustomerIDResult';
import { VehicleReservationCaseResult } from './../models/Booking/VehicleReservationCaseResult';
import { ViewBookingModel } from './../models/Booking/ViewBookingModel';
import { OnlineCustomerCancellationReasonModel } from './../models/Booking/OnlineCustomerCancellationReasonModel';
import { CheckCaseAvailabilityModel } from 'src/app/models/Booking/CheckCaseAvailabilityModel'
import { PaymentModel } from 'src/app/models/Booking/PaymentModel'
import { CurrencyModel } from '../models/CurrencyModel';
import { UpdateReservationSearchByAgencyResult } from 'src/app/models/Booking/UpdateReservationSearchByAgencyResult'
import { FindYourIdealCarMainModel, FindYourIdealCarModel } from 'src/app/models/Booking/FindYourIdealCarModel'
import { AvailablePaymentMethodModel } from 'src/app/models/Payments/AvailablePaymentMethodModel'
import { EvaluationParmModel } from 'src/app/models/Evaluation/EvaluationParmModel'
import { RentalServiceDeliveryChannel } from '../models/enums/Payments/PaymnetsEnum';
import { HttParamsHelper } from 'src/app/common/helpers/HttpParamsHelper'

@Injectable({
  providedIn: 'root'
})
export class BookingService {

  TermsAndCondition = "By confirming your booking; you are approving rental service terms and conditions. AVIS Rental Terms"

  private _reviewAdded = new BehaviorSubject<boolean>(null);
  readonly reviewAdded = this._reviewAdded.asObservable();

  private _findYourIdealCar = new BehaviorSubject<FindYourIdealCarMainModel>(null);
  readonly findYourIdealCar = this._findYourIdealCar.asObservable();


  private _vehicle = new BehaviorSubject<Vehicle>(null);
  readonly vehicle = this._vehicle.asObservable();

  private _searchModel = new ReplaySubject<VehicleReservationSearchParm>(null);
  readonly searchModel = this._searchModel.asObservable();

  public _vehicleReservationCaseDetailsModel = new BehaviorSubject<VehicleReservationCaseDetailsModel>(null);
  public vehicleReservationCaseDetailsModel = this._vehicleReservationCaseDetailsModel.asObservable();

  private _reservationSaveAndConfirmModel = new BehaviorSubject<ReservationSaveAndConfirmModel>(null);
  readonly reservationSaveAndConfirmModel = this._reservationSaveAndConfirmModel.asObservable();



  private _viewBookingModel = new BehaviorSubject<ViewBookingModel>(null);
  readonly viewBookingModel = this._viewBookingModel.asObservable();


  private _vehicleReservationCaseResult = new BehaviorSubject<VehicleReservationCaseResult>(null);
  readonly vehicleReservationCaseResult = this._vehicleReservationCaseResult.asObservable();



  private _driverSkills = new BehaviorSubject<DriverSkillModel[]>(null);
  readonly driverSkills = this._driverSkills.asObservable();

  private _viewBookingState = new BehaviorSubject<number>(0);
  readonly viewBookingState = this._viewBookingState.asObservable();

  private _dropOffLocation = new BehaviorSubject<any>(null);
  readonly dropOffLocation = this._dropOffLocation.asObservable();

  private dataStore: {
    dropOffLocation: any,
    findYourIdealCar: FindYourIdealCarMainModel,
    viewBookingState: number,
    driverSkills: DriverSkillModel[],
    vehicleReservationCaseResult: VehicleReservationCaseResult,
    viewBookingModel: ViewBookingModel,
    reservationSaveAndConfirmModel: ReservationSaveAndConfirmModel,
    vehicle: Vehicle,
    searchModel: VehicleReservationSearchParm,
    vehicleReservationCaseDetailsModel: VehicleReservationCaseDetailsModel,
    reviewAdded: boolean
  } = {
      dropOffLocation: null,
      findYourIdealCar: null,
      viewBookingState: 0,
      vehicleReservationCaseResult: null,
      viewBookingModel: null,
      reservationSaveAndConfirmModel: null,
      vehicle: null,
      searchModel: null,
      vehicleReservationCaseDetailsModel: null,
      driverSkills: null,
      reviewAdded: null
    };

  //Todo: change them to observable for the variable that it need that.
  public searchAvailableVehicleFilterType: VehicleSearchTypeEnum;
  public searchModelShared: any;//VehicleReservationSearchParm;
  public vehicleShared: Vehicle;
  public CaseID: string;
  public selectedBorders: CrossBorderModel[];
  selectedLanguage: LanguageModel;
  selectedLanguageIsoCode;
  private selectedCurrency: CurrencyModel;


  constructor(private http: HttpClient, private resouceService: ResourceService) {

    resouceService.selectedCurrency.subscribe(res => this.selectedCurrency = res);
    //Default isocode
    this.selectedLanguageIsoCode = "en";
    resouceService.selectedLanguage.subscribe(res => {

      this.selectedLanguage = res;
      if (res != null) {
        this.selectedLanguageIsoCode = res.isoCode2;
      }
    })
    let _cahcedVehicle = this.getCachedVehicle();
    if (_cahcedVehicle != null) {
      this.dataStore.vehicle = _cahcedVehicle;
      this._vehicle.next(Object.assign({}, this.dataStore).vehicle);
    }

    let _chachedSearch = this.getCachedSearchModel();
    if (_chachedSearch != null) {
      this.updateSearchModel(_chachedSearch);
    }
  }

  //#region  selected Vehcile Functions
  updateVehicle(vehicle: Vehicle) {
    this.dataStore.vehicle = vehicle;
    this._vehicle.next(Object.assign({}, this.dataStore).vehicle);
    this.cachedVehicle(vehicle);
  }
  cachedVehicle(vehicle) {
    sessionStorage.setItem('selectedVehicle', JSON.stringify(vehicle));
  }

  getCachedVehicle() {
    return JSON.parse(sessionStorage.getItem('selectedVehicle'));
  }
  //#endregion


  //#region  VehicleREservaionCaseDeails

  getVehicleReservationCaseDetails(model) {

    model["Lang"] = this.selectedLanguageIsoCode;
    model["CurrencyID"] = this.selectedCurrency.currencyID;
    model["RentalServiceDeliveryChannelID"] = RentalServiceDeliveryChannel.Online;
    model["RentalServiceDeliveryChannel"] = RentalServiceDeliveryChannel.Online;
    return this.http.post<VehicleReservationCaseDetailsModel>("VehicleReservationCase/GetVehicleReservationDetails", JSON.stringify(model));

  }

  updateVehicleReservationCaseDetails(model) {
    this.dataStore.vehicleReservationCaseDetailsModel = model;
    this._vehicleReservationCaseDetailsModel.next(Object.assign({}, this.dataStore).vehicleReservationCaseDetailsModel);
  }

  cachedBookingCaseID(CaseID: string) {
    sessionStorage.setItem('BookingCaseID', CaseID);
  }
  getCachedBookingCaseID() {
    return sessionStorage.getItem('BookingCaseID');
  }
  deleteCachedBookingCaseID() {
    sessionStorage.removeItem('BookingCaseID');
  }

  //#endregion


  getTermsAndCondition(agencyID) {
    return this.http.get(ApiControllerActionEnum.VehicleReservationTermsAndCondition + `?agencyID=${agencyID}&lang=${this.selectedLanguageIsoCode}`, { responseType: 'text' });
  }

  updateSearchModel(searcModel) {
    this.cachedSearchModel(searcModel);
    this.dataStore.searchModel = searcModel;
    this._searchModel.next(Object.assign({}, this.dataStore).searchModel);
  }
  cachedSearchModel(model) {
    localStorage.setItem('searchModel', JSON.stringify(model));
  }
  getCachedSearchModel() {
    return JSON.parse(localStorage.getItem('searchModel'));
  }

  //#region Additional Service Control Data
  getReturnLocations(agencyID) {
    return this.http.post(ApiControllerActionEnum.VehicleReservationGetReturnLocations + `?currencyID=${this.selectedCurrency.currencyID}&agencyID=${agencyID}&lang=${this.selectedLanguageIsoCode}&rentalServiceDeliveryChannelID=${RentalServiceDeliveryChannel.Online}`, {});
  }
  getDriverSkills() {
    return this.http.post<Array<DriverSkillModel>>(ApiControllerActionEnum.VehicleReservationGetDriversSkills + `?lang=${this.selectedLanguageIsoCode}`, {});
  }
  getOneWayRentalLocaions(agencyID, dropOffLocationID?, modeType?, isOneWayRentalTaxsable?, classID?, makeID?, modelID?, year?, vehicleID?, isExtend?) {
    let params = '?';
    params += 'agencyID=' + agencyID;
    params += '&lang=' + this.selectedLanguageIsoCode;
    params += '&currencyID=' + this.selectedCurrency.currencyID;
    params += '&rentalServiceDeliveryChannelID=' + RentalServiceDeliveryChannel.Online;

    if (dropOffLocationID != null) {
      params += "&dropOffLocationID=" + dropOffLocationID;
    }
    if (modeType != null) {
      params += "&modeType=" + modeType;
    }
    if (isOneWayRentalTaxsable != null) {
      params += "&isOneWayRentalTaxsable=" + isOneWayRentalTaxsable;
    }
    if (classID != null) {
      params += "&classID=" + classID;
    }
    if (makeID != null) {
      params += "&makeID=" + makeID;
    }
    if (modelID != null) {
      params += "&modelID=" + modelID;
    }
    if (year != null) {
      params += "&year=" + year;
    }
    if (vehicleID != null) {
      params += "&vehicleID=" + vehicleID;
    }1
    if (isExtend != null) {
      params += "&isExtend=" + isExtend;
    }

    return this.http.post<Array<OneWayRentalModel>>(ApiControllerActionEnum.VehicleReservationGetOneWayRentalReturnLocations + params, {});
  }
  getCrossBorders(agencyID, modeType?, selectedCrossedBorderIDs?) {
    let params = '?';
    params += 'agencyID=' + agencyID;
    params += '&&currencyID=' + this.selectedCurrency.currencyID;
    params += '&&lang=' + this.selectedLanguageIsoCode;
    if (modeType != null) {
      params += "&&modeType=" + modeType;
    }
    if (selectedCrossedBorderIDs != null) {
      params += "&&selectedCrossedBorderIDs=" + selectedCrossedBorderIDs;
    }

    return this.http.post<Array<CrossBorderModel>>(ApiControllerActionEnum.VehicleReservationGetCrossBorder + params, {});
  }
  //#endregion

  reservationSaveAndConfirm(model) {
    model["Lang"] = this.selectedLanguageIsoCode;
    model["CurrencyID"] = this.selectedCurrency.currencyID;
    model.TimeZoneCode = Intl.DateTimeFormat().resolvedOptions().timeZone;
    model["RentalServiceDeliveryChannelID"] = RentalServiceDeliveryChannel.Online;
    model["RentalServiceDeliveryChannel"] = RentalServiceDeliveryChannel.Online;
    return this.http.post<ReservationSaveAndConfirmModel>(ApiControllerActionEnum.VehicleReservationReservationSaveAndConfirm, JSON.stringify(model));
  }
  updateReservationSaveAndConfirm(model) {
    this.dataStore.reservationSaveAndConfirmModel = model;
    this._reservationSaveAndConfirmModel.next(Object.assign({}, this.dataStore).reservationSaveAndConfirmModel);
    localStorage.setItem('reservationSaveAndConfirm', JSON.stringify(model));
  }
  getCachedReservationSaveAndConfirm() {
    return JSON.parse(localStorage.getItem('reservationSaveAndConfirm'));
  }
  deleteCachedReservationSaveAndConfirm() {
    localStorage.removeItem('reservationSaveAndConfirm');
  }
  //#region  My Booking

  getVehicleReservationCasesByCustomerID(customerID, pageSize, pageNumber, stateId?) {
    let params = HttParamsHelper.getHttpParams();
    params = params.append('customerID', customerID);
    params = params.set('lang', this.selectedLanguageIsoCode);
    params = params.set('currencyID', this.selectedCurrency.currencyID.toString());
    params = params.set('pageSize', pageSize);
    params = params.set('pageNumber', pageNumber);
    if (stateId != null) {
      params = params.set('stateId', stateId);
    }
    let param = '?' + params.toString();
    return this.http.get<GetVehicleReservationCasesByCustomerID>(ApiControllerActionEnum.VehicleReservationMyBooking + param)
  }

  //#endregion

  //#region  Evaluation

  //For now only supported for vehicle type (must have vehicle ID)
  /*  getEvaluationSummary(vehicleID) {
     return this.http.get<EvaluationSummaryModel>(
       ApiControllerActionEnum.EvaluationSummary +
       `?vehicleID=${vehicleID}&lang=${this.selectedLanguageIsoCode}`
     );
   } */
  getEvaluationSummary(model: EvaluationParmModel) {
    model.Language = this.selectedLanguageIsoCode;
    return this.http.post<EvaluationSummaryModel>(ApiControllerActionEnum.EvaluationSummary, JSON.stringify(model));
  }
  getEvaluationLogsMasters(model) {
    return this.http
      .post<Array<EvaluationLogsMasterModel>>(
        ApiControllerActionEnum.EvaluationLogsMasters, JSON.stringify(model));
  }
  addPublicReview(model) {
    return this.http.post(ApiControllerActionEnum.AddPublicReview, JSON.stringify(model));
  }
  //#endregion


  //#region View Booking

  getVehicleReservationCase(caseID) {
    let timeZoneCode = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let rentalServiceDeliveryChannel = RentalServiceDeliveryChannel.Online;
    return this.http.post<VehicleReservationCaseResult>(ApiControllerActionEnum.VehicleReservationCase + `?caseID=${caseID}&currencyID=${this.selectedCurrency.currencyID}&rentalServiceDeliveryChannel=${rentalServiceDeliveryChannel}&lang=${this.selectedLanguage.isoCode2}`, {});
  }

  fetchVehicleFromVehicleReservationCase(model: VehicleReservationCaseResult): Vehicle {


    //Todo based on Type get the list
    //There is multiple places for vehcileID, MakeID, ModelID check wich one is the correct source
    let vehicle: Vehicle = {
      agencyID: model.agencyID,
      vehicleID: model.vehicleID,
      classID: model.classID,
      vehicleClass: model.vehicleClassName,
      makeID: model.makeID,
      vehicleOdometer: model.odometerView,
      plateNumber: model.plateNumber,
      modelID: model.modelID,
      durationUnitName: '',
      vehiclePrice: model.grandTotal,
      year: model.year,
      vehicleLocation: model.fromAgencyName,
      vehicleImage: 'assets/img/car.png',
      vehicleGearTypeList: model.featureList.gearBox.map(a => a.gearBoxName),
      vehiclePetrolTypeList: model.featureList.fuel.map(a => a.fuelName),
      vehiclePassengersNumberList: model.featureList.passengers.map(a => a.passengersName),
      vehicleDoorsNumberList: model.featureList.numberOfDoors.map(a => a.numberOfDoorsName),
      vehicleStorageList: model.featureList.storgeCapacity.map(a => a.storgeCapacityName),
      vehicleClassList: [model.vehicleClassName],
      vehicleName: model.makeModelYear,
      vehicleRentalNumber: model.totalRental,
      hasAirConditions: model.hasAirConditions,
      shownPricesIncludeTax: model.shownPricesIncludeTax,
      includeMandatoryCharges: model.includeMandatoryCharges,

    }



    if (model.vehicleColors != null) {
      vehicle.vehicleColors = JSON.parse(model.vehicleColors + "");
    }
    else {
      vehicle.vehicleColors = [model.extericColor];
    }
    /*      */
    //If vehicle
    //Todo: To be update

    if (true) {
      let _feature = model.featureList;

      vehicle.vehicleGearType = _feature.gearBox != null ? _feature.gearBox[0].gearBoxName : '';
      vehicle.vehiclePetrolType = _feature.fuel != null ? _feature.fuel[0].fuelName : '';
      vehicle.vehiclePassengersNumber = _feature.passengers != null ? _feature.passengers[0].passengersName : '';
      vehicle.vehicleDoorsNumber = _feature.numberOfDoors != null ? _feature.numberOfDoors[0].numberOfDoorsName : '';
      //vehicle.vehicleClass=_feature.vehicleType!=null?_feature.vehicleType[0].vehicleTypeName:'';
      vehicle.vehicleStorage = _feature.storgeCapacity != null ? _feature.storgeCapacity[0].storgeCapacityName : '';
      vehicle.vehicleOdometer = model.odometerView;
    }
    return vehicle;
  }
  updateViewBookingModel(model) {
    this.dataStore.viewBookingModel = model;
    this._viewBookingModel.next(Object.assign({}, this.dataStore).viewBookingModel);
  }
  updateVehicleReservationCaseResult(model) {
    this.dataStore.vehicleReservationCaseResult = model;
    this._vehicleReservationCaseResult.next(Object.assign({}, this.dataStore).vehicleReservationCaseResult);
  }
  updateDriverSkills(model) {
    this.dataStore.driverSkills = model;
    this._driverSkills.next(Object.assign({}, this.dataStore).driverSkills);
  }

  getOnlineCustomerCancellationReason() {
    return this.http.get<Array<OnlineCustomerCancellationReasonModel>>(ApiControllerActionEnum.GetOnlineCustomerCancellationReason + `?lang=${this.selectedLanguageIsoCode}`);
  }
  checkAvailabilityVehicleForExtensionPeriod(caseID, endDate, endTime, dropOffLocationID, dropOffLocationTypeID) {
    let timeZoneCode = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let rentalServiceDeliveryChannel = RentalServiceDeliveryChannel.Online;

    return this.http.get(ApiControllerActionEnum.CheckAvailabilityVehicleForExtensionPeriod + `?caseID=${caseID}&endDateString=${endDate}&endTimeString=${endTime}&currencyID=${this.selectedCurrency.currencyID}&rentalServiceDeliveryChannel=${rentalServiceDeliveryChannel}&timeZoneCode${timeZoneCode}&dropOffLocationID=${dropOffLocationID}&dropOffLocationTypeID=${dropOffLocationTypeID}&lang=${this.selectedLanguage.isoCode2}`, {});
  }

  reservationCancelConfirmed(caseID, resonID, comments) {
    return this.http.post(ApiControllerActionEnum.ReservationCancelConfirmed + `?caseID=${caseID}&resonID=${resonID}&comments=${comments}&currencyID=${this.selectedCurrency.currencyID}`, {});
  }

  checkReservationCaseAvailability(model) {
    model["CurrencyID"] = this.selectedCurrency.currencyID;
    model["RentalServiceDeliveryChannelID"] = RentalServiceDeliveryChannel.Online;
    model["RentalServiceDeliveryChannel"] = RentalServiceDeliveryChannel.Online;
    model["TimeZoneCode"] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    model["Lang"] = this.selectedLanguageIsoCode;
    return this.http.post<CheckCaseAvailabilityModel>(ApiControllerActionEnum.CheckReservationCaseAvailability, JSON.stringify(model));
  }
  updateConfirmedRentalPeriod(model) {
    model["CurrencyID"] = this.selectedCurrency.currencyID;
    model["RentalServiceDeliveryChannelID"] = RentalServiceDeliveryChannel.Online;
    model["RentalServiceDeliveryChannel"] = RentalServiceDeliveryChannel.Online;
    model["TimeZoneCode"] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    model["Lang"] = this.selectedLanguageIsoCode;
    return this.http.post(ApiControllerActionEnum.UpdateConfirmedRentalPeriod, JSON.stringify(model));
  }

  reservationCaseToViewBookingModel(res: VehicleReservationCaseResult) {

    //Deep Copy for additional service
    //To Prevent two way changing in non-related component
    let copiedAdditionalService;
    copiedAdditionalService = Object.assign([], copiedAdditionalService, res.vehicleReservationDetailsModel.lstAdditionalServiceReservationCase);


    //The Model
    let _viewBooking: ViewBookingModel = {
      endTimeString: res.endTimeString,
      endDate: res.endDate,
      dropOffLocationTypeID: res.dropOffLocationTypeID,
      caseStateID: res.caseStateID,
      lstAdditionalServiceReservationCase: copiedAdditionalService,
      lstPolicyReservationCaseModel: res.vehicleReservationDetailsModel
        .lstPolicyReservationCaseModel,
      driver: res.customerModel,
      isPickupAddress: res.isPickupAddress,
      pickupAddress: res.pickupAddress,
      isReturnAddress: res.isReturnAddress,
      returnAddress: res.returnAddress,
      selectedSkillIds: res.vehicleReservationDetailsModel
        .selectedSkillIds != null ? res.vehicleReservationDetailsModel
          .selectedSkillIds.split(',') : [],
      agencyID: res.agencyID,
      bookingNumber: res.bookingNumberFormatted,
      paid: res.paid,
      outStandingBalance: res.outStandingBalance,
      grandTotal: res.grandTotal,
      oneWayRental: res.toAgencyName,
      oneWayRentalModel: this.fetechOneWayRentalFromReservationCase(res),
      caseID: res.caseID,
      caseStatus: res.vehicleReservationStateName,
      durationInDays: res.durationInDays,
      taxPercentage: res.taxePercanteage,
      durationUnitName: res.durationUnitName,
      vehicleReservationCaseRentalPeriodModel: res.vehicleReservationCaseRentalPeriodModel,
      vehicleReservationDetailsModel: res.vehicleReservationDetailsModel,
      summaryChargePickUpLocationAddress: res.summaryChargePickUpLocationAddress,
      fromAgencyName: res.fromAgencyName,
      latitude: res.latitude,
      longitude: res.longitude,
      fromAgencyEmail: res.fromAgencyEmail,
      fromAgencyPhone: res.fromAgencyPhone,
      startDateString: res.startDateString,
      endDateString: res.endDateString,
      dropOffLatitude: res.dropOffLattitude,
      dropOffLongitude: res.dropOffLongitude,
      dropOffLocationID: res.dropOffLocationID,
      lstVehicleReservationCaseNonWorkingHoursChargeModel: res.vehicleReservationDetailsModel.lstVehicleReservationCaseNonWorkingHoursChargeModel

    }
    if (res.startDate != null) {

      const date1 = new Date(res.startDate).getTime();
      const date2 = new Date().getTime();
      const diffTime = date1 - date2;
      if (diffTime > 0) {
        _viewBooking.countDownInSec = diffTime / 1000;
      }

    }
    return _viewBooking;
  }
  fetechOneWayRentalFromReservationCase(res: VehicleReservationCaseResult) {
    let model: OneWayRentalModel = {
      agencyReturnLocationTypeID: res.dropOffLocationTypeID,
      returnAgencyID: res.dropOffLocationID,
      agencyReturnLocationName: res.toAgencyName,
    }
    return model;
  }


  //#endregion



  reservationExtendContract(caseID, endDate, endTime, dropOffLocaionID, dropOffLocationTypeID) {
    let timeZoneCode = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let rentalServiceDeliveryChannel = RentalServiceDeliveryChannel.Online;
    let params = HttParamsHelper.getHttpParams();
    params = params.append('caseID', caseID);
    params = params.set('endDateString', endDate);
    params = params.set('endTimeString', endTime);
    params = params.set('currencyID', this.selectedCurrency.currencyID.toString());
    params = params.set('rentalServiceDeliveryChannel', rentalServiceDeliveryChannel.toString());
    params = params.set('timeZoneCode', timeZoneCode);
    params = params.set('dropOffLocationID', dropOffLocaionID);
    params = params.set('dropOffLocationTypeID', dropOffLocationTypeID);
    params = params.set('lang', this.selectedLanguage.isoCode2);
    console.log(params.toString())
    return this.http.get(ApiControllerActionEnum.ReservationExtendContract + '?' + params.toString(), {});
  }
  updateViewBookingState() {

    let num = Math.floor(Math.random() * 10) + 1;

    this.dataStore.viewBookingState = num;
    this._viewBookingState.next(Object.assign({}, this.dataStore).viewBookingState);

  }

  updateConfirmedAdditionalService(model) {
    model["Lang"] = this.selectedLanguageIsoCode;
    model["CurrencyID"] = this.selectedCurrency.currencyID;
    model["RentalServiceDeliveryChannelID"] = RentalServiceDeliveryChannel.Online;
    model["RentalServiceDeliveryChannel"] = RentalServiceDeliveryChannel.Online;
    return this.http.post(ApiControllerActionEnum.ReservationUpdateConfirmedAdditionalService, JSON.stringify(model));

  }
  getReservationCaseAdditionalService(model) {
    model["Lang"] = this.selectedLanguageIsoCode;
    model["CurrencyID"] = this.selectedCurrency.currencyID;
    model["RentalServiceDeliveryChannelID"] = RentalServiceDeliveryChannel.Online;
    model["RentalServiceDeliveryChannel"] = RentalServiceDeliveryChannel.Online;
    return this.http.post<Array<LstAdditionalServiceReservationCase>>(ApiControllerActionEnum.GetReservationCaseAdditionalService, JSON.stringify(model));
  }

  checkCustomerElegibility(model) {
    model['currentLanguage'] = this.selectedLanguageIsoCode;
    return this.http
      .post<Array<CustomerElegibility>>(ApiControllerActionEnum.CheckCustomerElegibility
        , JSON.stringify(model));
  }

  updateCustomer(model) {
    return this.http.post(ApiControllerActionEnum.UpdateCustomer, JSON.stringify(model));
  }


  //#region Find Your Ideal Car
  updateVehicleReservationSearchByAgency(model) {
    model["CurrentLanguage"] = this.selectedLanguage.isoCode2;
    model["CurrencyID"] = this.selectedCurrency.currencyID;
    model["RentalServiceDeliveryChannelID"] = RentalServiceDeliveryChannel.Online;
    model["RentalServiceDeliveryChannel"] = RentalServiceDeliveryChannel.Online;
    model["TimeZoneCode"] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return this.http.post<UpdateReservationSearchByAgencyResult>(ApiControllerActionEnum.UpdateVehicleReservationSearchByAgency, JSON.stringify(model));
  }
  updateFindYourIdealCar(model) {
    this.dataStore.findYourIdealCar = model;
    this._findYourIdealCar.next(Object.assign({}, this.dataStore).findYourIdealCar);

  }
  //#endregion



  //#region  Payments

  getAvailablePaymentMethods(customerID, rentalServiceDeliveryChannel?) {
    let rentalServiceDeliveryChannelId = RentalServiceDeliveryChannel.Online;
    if (rentalServiceDeliveryChannel != null) {
      rentalServiceDeliveryChannelId = rentalServiceDeliveryChannel;
    }
    //return this.http.get(ApiControllerActionEnum.GetAvailablePaymentMethods+`?language=${this.selectedLanguageIsoCode}`)
    return this.http.get<Array<AvailablePaymentMethodModel>>(ApiControllerActionEnum.GetAvailablePaymentMethods + `?customerID=${customerID}&language=${this.selectedLanguageIsoCode}&rentalServiceDeliveryChannelId=${rentalServiceDeliveryChannelId}`)
  }
  proceedPayment(model) {
    model["RentalServiceDeliveryChannel"] = RentalServiceDeliveryChannel.Online;
    model["TimeZoneCode"] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    model["CurrencyID"] = this.selectedCurrency.currencyID;
    return this.http.post(ApiControllerActionEnum.ProceedPayment, JSON.stringify(model))
  }


  getPayments(customerID, caseID) {

    let params = HttParamsHelper.getHttpParams();
    params = params.append('caseID', caseID);
    params = params.set('customerID', customerID);
    params = params.set('currencyID', this.selectedCurrency.currencyID.toString());
    params = params.set('lang', this.selectedLanguage.isoCode2);

    return this.http.get<Array<PaymentModel>>(ApiControllerActionEnum.GetPayments + '?' + params.toString())
  }

  getAccountStatment(customerID, agencyID, caseID, dateFrom, dateTo) {

    let params = HttParamsHelper.getHttpParams();
    params = params.set('customerID', customerID);
    params = params.append('agencyID', agencyID);
    params = params.append('caseID', caseID);
    params = params.set('dateFrom', dateFrom);
    params = params.set('dateTo', dateTo);
    params = params.set('currencyID', this.selectedCurrency.currencyID.toString());

    return this.http.get<AccountStatmentModel>(ApiControllerActionEnum.GetAccountStatment + '?' + params.toString())
  }

  getReceivedPayment(PaymentID, paymentGatewayID) {
    return this.http.get<Array<RecivedPaymentModel>>(ApiControllerActionEnum.GetReceivedPayment + `?PaymentID=${PaymentID}+&paymentGatewayID=${paymentGatewayID}&currencyID=${this.selectedCurrency.currencyID}`)
  }





  //#endregion

  //#region  Latest Campaigns (Top Deals)

  getLatestCampaigns() {
    return this.http.get<Array<LatestCampaignModel>>(ApiControllerActionEnum.GetLatestCampaigns + `?lang=${this.selectedLanguageIsoCode}`);
  }

  //#region

  //#region

  getCancelationPolicy(caseID) {
    let lang = this.selectedLanguageIsoCode;

    let timeZoneCode = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let rentalServiceDeliveryChannel = RentalServiceDeliveryChannel.Online;
    return this.http.get(ApiControllerActionEnum.GetCancelationPolicy + `?caseID=${caseID}&currencyID=${this.selectedCurrency.currencyID}&timeZone=${timeZoneCode}&rentalServiceDeliveryChannel=${rentalServiceDeliveryChannel}`);
  }

  //#endregion



  //#region  One Way Rental (DropOffLocation) Change

  updateDropOffLocation(model) {
    this.dataStore.dropOffLocation = model;
    this._dropOffLocation.next(Object.assign({}, this.dataStore).dropOffLocation);
  }

  //#endregion


  //#region WorkingHours

  getWorkingHoursSetting(model) {
    model["CurrencyID"] = this.selectedCurrency.currencyID;
    return this.http.post<WorkingHoursSettingModel>(ApiControllerActionEnum.GetWorkingHoursSetting, JSON.stringify(model));

  }
  //#endregion


  updateReviewAddedStatus(status) {
    this.dataStore.reviewAdded = status;
    this._reviewAdded.next(Object.assign({}, this.dataStore).reviewAdded);
  }

}






